module.exports = __webpack_public_path__ + "img/44.7ff74d2b.jpg";